import { get } from "helpers/api_helper"
import { GET_CustomerPODetail, GET_PurchaseOrderDetail } from "helpers/url_helper"
import moment from "moment"
import { useEffect, useState } from "react"
import { NavLink } from "react-router-dom"
import { Link } from "react-router-dom"
import { Col, Row, Input, Nav, NavItem, TabContent, TabPane, Label } from "reactstrap"
import swal from "sweetalert"

const PODetailCustomer = ({ hooks }) => {
    let { Auth, poListCustomerData, ID, navigate, viewMore, setIsLoading,
        setViewMore, classnames, mode, setHide, setShowSwalError, setSwalErrorMsg } = hooks

    const [Id, setID] = useState(ID)
    const [values, setValues] = useState({})
    const [orderItemDetail, setOrderItemDetail] = useState([])
    console.log("PODetailCustomerPODetailCustomer", poListCustomerData)
    const getPurchaseOrderDetail = id => {
        setIsLoading(true)
        get(GET_CustomerPODetail + id)
            .then(response => {
                if (response?.status == 200) {
                    let data = response?.data
                    setValues(data)
                    setOrderItemDetail(data?.order_item)
                    console.log(data?.order_item)

                } else {
                    if (typeof response?.message == "string") {
                        swal({
                            title: "Error!",
                            text: response.message,
                            icon: "error",
                            button: "OK",
                        })
                    } else {
                        setSwalErrorMsg(response?.message)
                        setShowSwalError(true)
                    }
                }
            })
            .catch(error => {
                console.log(error)
                setIsLoading(false)
            })
        setIsLoading(false)
    }

    const sumQunValues = (data) => {
        return data.reduce((sum, item) => {
            const value = parseInt(item.quantity, 10);
            return sum + (isNaN(value) ? 0 : value);
        }, 0);
    };

    const formatAddress = item => {
        const addressParts = [
          item.address_line_1,
          item.address_line_2,
          item.address_line_3,
          [item?.city?.city_name, item?.state?.state_name].filter(Boolean).join(", "),
          [item?.country?.name, item.zip_code].filter(Boolean).join(" - "),
        ].filter(Boolean);
      
        return addressParts.join(",<br/>");
    }; 


    useEffect(() => {
        if (Id) {
            getPurchaseOrderDetail(Id)
        }
    }, [Id])
    return (
        <>
            <Row>
                <Col
                    lg={3}
                    md={3}
                    sm={3}
                    style={{
                        height: "100%",
                    }}
                >
                    <Row style={{ background: "#f0f0f0", marginLeft: "-25px" }}>
                        <Col
                            lg={12}
                            md={12}
                            sm={12}
                            style={{ marginTop: "20px", marginBottom: "6px" }}
                        >
                            <div className="d-flex">
                                <div style={{ width: "400px" }}>
                                    All Purchase Order
                                </div>
                                <div style={{ textAlign: "right", width: "100%" }}>
                                    {Auth?.permissions?.filter(
                                        x => x.resource_id == 14 && x.create_per == 1
                                    )?.length > 0 ? (
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                navigate("/add-purchase-order-customer")
                                            }}
                                            style={{
                                                padding: "0.05rem 0.5rem",
                                            }}
                                        >
                                            + New
                                        </button>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col
                            lg={12}
                            md={12}
                            sm={12}
                            style={{
                                borderTop: "1px solid #cacaca",
                            }}
                        >
                            {poListCustomerData?.map((x, i) => (
                                <Row
                                    style={{
                                        marginBottom: "5px",
                                        marginTop: "5px",
                                        backgroundColor: x.id === Id ? "#cecece96" : "",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        setID(x?.id)
                                    }}
                                >
                                    {console.log("xxxxxxxxxxxxxx", x)}
                                    <div className="col-1 col-lg-1 col-md-1 col-sm-2">
                                        {" "}
                                        <Input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="check"
                                            checked={false}
                                        />
                                    </div>
                                    <div className="col col-lg-6 col-md-6 col-sm-6">
                                        <text>{x?.organization?.company_name}</text>
                                        <br></br>
                                        <div
                                            style={{ fontSize: "10px", marginTop: "6px" }}
                                        >
                                            <Link to="#"> {x.purchase_order_no}</Link>{" "}
                                            |&nbsp;
                                            {x.purchase_order_date
                                                ? moment(x.purchase_order_date)
                                                    .format("DD-MMM-YYYY")
                                                    .replace(/^\-/, "")
                                                : ""}
                                        </div>
                                    </div>
                                    <div
                                        className="col col-lg-5 col-md-5 col-sm-4"
                                        style={{
                                            marginLeft: "-2px",
                                            textAlign: "end",
                                            padding: "0.05rem 0.5rem",
                                        }}
                                    >
                                        <text>
                                            Rs.{" "}
                                            {x.total
                                                ? parseFloat(x.total).toFixed(2)
                                                : "0.00"}
                                        </text>
                                        <br></br>
                                        <text
                                            style={{
                                                color:
                                                    x.po_status === "draft"
                                                        ? "grey"
                                                        : x.po_status === "approval"
                                                            ? "#798ad8"
                                                            : "green",
                                                textTransform: "uppercase",
                                                fontSize: "10px",
                                            }}
                                        >
                                            {x.po_status}
                                        </text>
                                    </div>
                                </Row>
                            ))}
                        </Col>
                    </Row>
                </Col>

                <Col
                    lg={9}
                    md={9}
                    sm={9}
                    style={{ borderLeft: "1px solid #cacaca" }}
                >
                    <Row>
                        <Col
                            lg={12}
                            style={{
                                marginTop: "20px",
                            }}
                        >
                            <div style={{ fontSize: "16px", color: "grey" }}>
                                {values?.purchase_order_no}
                            </div>
                            <div style={{ textAlignLast: "end" }}>
                                <button
                                    type="button"
                                    className="btn"
                                    style={{
                                        marginTop: "-50px",
                                        fontSize: "20px",
                                        position: "sticky",
                                        border: 0,
                                    }}
                                    onClick={() => setHide(1)}
                                >
                                    <span>×</span>
                                </button>
                            </div>
                        </Col>
                        <Col lg={12} style={{ borderTop: "1px solid #cacaca" }}>
                            <Row style={{ backgroundColor: "#f8f9fa00" }}>
                                <Col lg={12} md={12} sm={12}>
                                    <Row>
                                        <Row>
                                            {values?.ammend_request && values?.ammend_request?.request &&
                                                <>
                                                    <text
                                                        style={{
                                                            fontSize: "20px",
                                                            color: "black",
                                                        }}
                                                    >
                                                        AMMEND REQUEST NOTE
                                                    </text>
                                                    < text
                                                        style={{
                                                            fontSize: "15px",
                                                            color: "black",
                                                            margin: "20px"
                                                        }}
                                                    >
                                                        <b>{values?.ammend_request?.request}</b>
                                                    </text>
                                                </>
                                            }
                                            <hr />
                                        </Row>
                                        <Col lg={6} md={12} sm={12}>
                                            <text
                                                style={{
                                                    fontSize: "20px",
                                                    color: "black",
                                                }}
                                            >
                                                PURCHASE ORDER
                                            </text>
                                            <br></br>
                                            <text>
                                                Purchase Order#<b>  {values?.purchase_order_no}</b>
                                            </text>
                                            <Row style={{ marginTop: "30px" }}>
                                                <Col lg={2}>
                                                    <button
                                                        className="btn btn-primary"
                                                        disabled
                                                        style={{
                                                            padding: "0.05rem 0.5rem",
                                                            borderColor:
                                                                values.po_status ===
                                                                    "saved"
                                                                    ? "green"
                                                                    : values.po_status ===
                                                                        "draft"
                                                                        ? "#798ad8"
                                                                        : "gray",
                                                            backgroundColor:
                                                                values.po_status ===
                                                                    "saved"
                                                                    ? "green"
                                                                    : values.po_status ===
                                                                        "draft"
                                                                        ? "#798ad8"
                                                                        : "gray",
                                                            textTransform: "uppercase",
                                                        }}
                                                    >
                                                        {values?.po_status}
                                                    </button>
                                                </Col>
                                            </Row>

                                            <Row style={{ marginTop: "15px" }}>
                                                <Col lg={7} md={12} sm={12}>
                                                    <b>PO NUMBER</b>
                                                </Col>
                                                <Col lg={5} md={5} sm={12}>
                                                    {values?.purchase_order_no}
                                                </Col>
                                            </Row>
                                            <Row style={{ marginTop: "15px" }}>
                                                <Col lg={7} md={12} sm={12}>
                                                    <b>PO DATE</b>
                                                </Col>
                                                <Col lg={5} md={5} sm={12}>
                                                    {values?.purchase_order_date
                                                        ? moment(
                                                            values?.purchase_order_date
                                                        )
                                                            .format("DD-MMM-YYYY")
                                                            .replace(/^\-/, "")
                                                        : ""}
                                                </Col>
                                            </Row>

                                            <Row style={{ marginTop: "15px" }}>
                                                <Col lg={7} md={12} sm={12}>
                                                    <b>PAYMENT TERMS</b>
                                                </Col>
                                                <Col lg={5} md={5} sm={12}>
                                                    {console.log("values?.terms_and_conditions", values?.terms_and_conditions)}
                                                    {values?.payment_term?.label || '-'}
                                                    {/* {values?.terms_and_conditions && values?.terms_and_conditions.length ? (
                                                        values.terms_and_conditions
                                                            .filter(item => item.dropdown === "PAYMENT TERMS")
                                                            .map((item, index) => (
                                                                <div key={index}>
                                                                    <p>{item.text}</p>
                                                                </div>
                                                            ))
                                                    ) : (
                                                        "-"
                                                    )} */}
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={1}></Col>
                                        <Col
                                            lg={5}
                                            md={12}
                                            sm={12}
                                            style={{ marginTop: "15px" }}
                                        >
                                            {" "}
                                            <text>
                                                <b>VENDOR</b><br></br>
                                                {values?.contact?.display_name}
                                            </text>
                                            <br></br>
                                            <text>{values?.contact?.company_name}</text>
                                            <br></br>
                                            <br></br>
                                            <Row style={{ marginTop: "30px" }}>
                                                <Col lg={12} md={12} sm={12}>
                                                    <b>DELIVERY ADDRESS</b>
                                                    {/* {values?.contact?.display_name} */}

                                                    {/* contact > addresses if type is shiping show shiping object info else 0 index */}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={12} md={12} sm={12}>
                                                <div>
                                                    {values?.shipping_address ? (
                                                    <div>
                                                        {values.shipping_address.attention && (
                                                        <p>Attention: {values.shipping_address.attention}</p>
                                                        )}
                                                        <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: formatAddress(values.shipping_address),
                                                        }}
                                                        />
                                                    </div>
                                                    ) : (
                                                    "-"
                                                    )}
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                {/* <Col
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    style={{ textAlign: "right" }}
                                                >
                                                    <button
                                                        className="btn btn-light"
                                                        type="button"
                                                        onClick={() => {
                                                            setFulfillmentPlanModal(true)
                                                        }}
                                                    >
                                                        View Fulfillment Plan
                                                    </button>
                                                </Col> */}
                                            </Row>
                                        </Col>
                                    </Row>

                                    <Row style={{ marginTop: "10px" }}>
                                        <Col lg={12}>
                                            <div className="table-responsive">
                                                <table className="table mb-0">
                                                    <thead>
                                                        <tr className="table-light">
                                                            <th style={{ minWidth: "220px" }}>
                                                                ITEMS & DESCRIPTION
                                                            </th>
                                                            <th style={{ minWidth: "100px" }}>
                                                                ORDERED QUANTITY
                                                            </th>
                                                            <th style={{ minWidth: "250px" }}>
                                                                FULFILLMENT AND PLANNING
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {orderItemDetail?.map((x, i) => (
                                                            <tr>
                                                                <td>
                                                                    &nbsp;
                                                                    <span>
                                                                        {x.product?.product_name}
                                                                        <br></br>
                                                                        {x.description}
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    {sumQunValues(x.expected_delivery_date_and_qty)} <br></br>
                                                                </td>
                                                                <td>
                                                                    {x.expected_delivery_date_and_qty?.map(
                                                                        (y, z) => (
                                                                            <>
                                                                                Delivery Date : &nbsp;
                                                                                {`${moment(
                                                                                    y?.expected_delivery_date
                                                                                )
                                                                                    .format("DD-MMM-YYYY")
                                                                                    .replace(/^\-/, "")}`}
                                                                                <br></br>
                                                                                Delivery Quantity : &nbsp;
                                                                                {y?.quantity
                                                                                    ? y?.quantity
                                                                                    : 0}
                                                                                <br></br>
                                                                            </>
                                                                        )
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>{" "}
                                        </Col>
                                        <text
                                            style={{
                                                fontSize: "20px",
                                                color: "black",
                                                marginTop: "20px"
                                            }}
                                        >
                                            ATTACHEMENTS
                                        </text>

                                        {values?.order_file?.length > 0 ? values?.order_file?.map((file, i) => {
                                            return <Col key={file?.file?.id} lg={12} style={{ marginBottom: "20px" }}>
                                                <hr></hr>
                                                <div>
                                                    <b>{file?.file?.file_name}</b>{" "}
                                                    &nbsp;
                                                    <a
                                                        href={file?.file?.file_url}
                                                        target="_blank"
                                                        download={file?.file?.file_name}>
                                                        <i className="ti-download" />
                                                        Download
                                                    </a>
                                                </div>
                                            </Col>
                                        }) : <text style={{ marginBottom: "20px" }}> No Attachement Found.</text>}
                                    </Row>

                                </Col>

                            </Row>

                        </Col>
                    </Row>

                </Col >


            </Row >
        </>
    )
}

export default PODetailCustomer;